import React, {useCallback, useContext, useState, useEffect} from 'react';
import {withRouter} from 'react-router';

import {pushQueryParams} from 'client/history';
import {Button, Icon, WithTooltip} from '@albert-io/atomic';

import {ReportsContext} from '../../Reports.context';
import {DIMENSIONS} from '../../reports.utils';
import SelectDropdown from '../../SelectDropdown/SelectDropdown.react';

function AttemptFilter() {
  const {loading, attemptNumber, path} = useContext(ReportsContext);

  const [options, setOptions] = useState<object[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = useCallback((attempt) => {
    pushQueryParams({attempt});
  }, []);

  useEffect(() => {
    const updatedOptions: object[] = [];

    for (let num = 1; num <= 10; num += 1) {
      updatedOptions.push({
        id: `${num}`,
        value: `${num}`,
        label: `${num}`
      });
    }

    updatedOptions.unshift({id: 'mostRecent', value: 'mostRecent', label: 'Most recent'});

    setOptions(updatedOptions);
  }, []);

  const hasAssignmentInDrilldown =
    path.includes(DIMENSIONS.assignments) || path.includes('gradebook');

  // The onClick is passed from the SelectDropdown component so we need to conditially wrap the tooltip
  const selectTrigger = hasAssignmentInDrilldown ? (
    <WithTooltip enabled content='Assignments only have one attempt' placement='bottom'>
      <Button
        disabled={loading || hasAssignmentInDrilldown}
        as='button'
        variant='faded'
        className='u-cursor_pointer'
      >
        <b>Attempt: &nbsp;</b> {attemptNumber === 'mostRecent' ? 'Most Recent' : attemptNumber}
        <Icon icon='caret-down' className='u-mar-l_2' />
      </Button>
    </WithTooltip>
  ) : (
    <Button disabled={loading} as='button' className='u-cursor_pointer' variant='faded'>
      <b>Attempt: &nbsp;</b> {attemptNumber === 'mostRecent' ? 'Most Recent' : attemptNumber}
      <Icon icon='caret-down' className='u-mar-l_2' />
    </Button>
  );

  return (
    <SelectDropdown
      disabled={loading || hasAssignmentInDrilldown}
      key={options.length}
      label='Add filter'
      options={options}
      onSelect={(item) => handleChange(item.value)}
      trigger={selectTrigger}
      isSelected={(selectedItem) => selectedItem.value === attemptNumber}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
}

export default withRouter(AttemptFilter);
